<script lang="ts">
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "GeschuetzterRouterLink",
  components: {},
  props: {
    to: String,
  },
  setup(props) {
    const gesperrteRouten = process.env.VUE_APP_ROUTEN_GESPERRT.split(",");
    const gesperrt = computed(() => gesperrteRouten.includes(props.to));

    return { props, gesperrt };
  },
});
</script>

<template>
  <router-link :to="to" v-if="!gesperrt">
    <slot></slot>
  </router-link>
</template>

<style scoped></style>
